import { Link } from "react-router-dom";
import { Sigle, useBranding } from "../../branding";
import { ButtonLink, cx } from "../../components";
import { homeFor, useSession } from "../../session";
import { ROUTES } from "../../shell";
import styles from "./Vitrine.module.css";
import { useLiensTransition } from "../../motion";

/**
 * L'en-tête de la vitrine : la marque, trois ancres, et la porte d'entrée.
 * Connecté, la porte devient « Mon espace » : la vitrine reste visible en
 * démonstration sans expulser qui l'ouvre depuis son espace.
 */
export function VitrineEntete() {
  const lien = useLiensTransition();
  const { state } = useSession();
  const { product_short, product_name } = useBranding();

  return (
    <header className={cx(styles.sombre, styles.entete)}>
      <Link to={ROUTES.accueil} className={styles.marque} aria-label={`${product_short}, accueil`}>
        <Sigle className={styles.sigle} />
        <span className={styles.nomMarque}>{product_name}</span>
      </Link>

      <nav className={styles.ancres} aria-label="Sections de la page">
        <a href="#etapes">Comment ça marche</a>
        <a href="#espaces">Les espaces</a>
        <a href="#grand-livre">Le grand livre</a>
      </nav>

      <div className={styles.porte}>
        {state.status === "loading" ? (
          <span className={styles.porteAttente} aria-hidden="true" />
        ) : state.status === "authenticated" ? (
          <ButtonLink to={homeFor(state)} variant="primary">
            Mon espace
          </ButtonLink>
        ) : (
          <>
            <Link to={ROUTES.connexion} className={styles.lienEntete} {...lien(ROUTES.connexion, "cube-avant")}>
              Se connecter
            </Link>
            <ButtonLink to={ROUTES.inscription} variant="primary" {...lien(ROUTES.inscription, "cube-avant")}>
              Inscription
            </ButtonLink>
          </>
        )}
      </div>
    </header>
  );
}
